import { render } from "./WhatsNewDialog.vue?vue&type=template&id=2d1b6a7a&scoped=true"
import script from "./WhatsNewDialog.vue?vue&type=script&lang=js"
export * from "./WhatsNewDialog.vue?vue&type=script&lang=js"

import "./WhatsNewDialog.vue?vue&type=style&index=0&id=2d1b6a7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1b6a7a"]])

export default __exports__